export default __webpack_public_path__ + "static/media/Trend4.37d75514.svg";